import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { deleteUserApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const deleteUser = createAsyncThunk('deleteUser', async (payload) => {
  return await deleteUserApi(payload);
});

const deleteUserSlice = createSlice({
  name: 'deleteUser', // Unique Name
  initialState,
  reducers: {
    deleteUserReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteUser.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(deleteUser.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { deleteUserReset } = deleteUserSlice.actions;

export default deleteUserSlice.reducer;
